/**
 * @generated SignedSource<<d87e1e6f037117a09332cb6476b1b7fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useAutoRefetchMeetingRecording_note" | "utils_useNoteHasRecordings_note">;
  readonly " $fragmentType": "MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note";
};
export type MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note$key = {
  readonly " $data"?: MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useNoteHasRecordings_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useAutoRefetchMeetingRecording_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "cbb60bb617568e3c5414aacb5c7d0504";

export default node;
